// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { intervalToDuration as fn } from "../intervalToDuration.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const intervalToDurationWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default intervalToDurationWithOptions;
